import { CATEGORIES } from "@/constants/data";

/**
 * Step 2: property type selection (Daire / Arsa / Tarla / Bahçe).
 */
const PropertyTypeStep = ({ value, onSelect }) => (
  <div className="grid grid-cols-2 gap-3" data-testid="inquiry-property-type-select">
    {CATEGORIES.map((cat) => {
      const Icon = cat.icon;
      const active = value === cat.value;
      return (
        <button
          key={cat.value}
          type="button"
          data-testid={`inquiry-property-type-${cat.value}`}
          onClick={() => onSelect(cat.value)}
          className={`flex flex-col items-center gap-2 rounded-[12px] border p-4 text-sm font-medium transition-colors ${
            active
              ? "border-[color:var(--brand-gold)] bg-[color:hsl(var(--secondary))] text-[color:var(--brand-charcoal)]"
              : "border-[color:var(--line)] text-[color:hsl(var(--muted-foreground))] hover:bg-[color:hsl(var(--secondary))]"
          }`}
        >
          <Icon className={`h-5 w-5 ${active ? "text-[color:var(--brand-gold-2)]" : ""}`} />
          {cat.label}
        </button>
      );
    })}
  </div>
);

export default PropertyTypeStep;
